function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.250459 0 0 0 0 0.319048 0 0 0 0 0.365496 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ActionBar320/Default",
  transform: "translate(-17.000000, -19.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-M/OnLight/Visibility/Default/On",
  transform: "translate(16.000000, 14.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-68",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,18.3554688 C18.0078125,18.3554688 22.1171875,13.5039062 22.1171875,11.9960938 C22.1171875,10.4804688 18,5.64453125 12,5.64453125 C6.0859375,5.64453125 1.8828125,10.4804688 1.8828125,11.9960938 C1.8828125,13.5039062 6.078125,18.3554688 12,18.3554688 Z M12,17.0898438 C7.1875,17.0898438 3.3203125,13.0351562 3.3203125,11.9960938 C3.3203125,11.1210938 7.1875,6.90234375 12,6.90234375 C16.8046875,6.90234375 20.6796875,11.1210938 20.6796875,11.9960938 C20.6796875,13.0351562 16.8046875,17.0898438 12,17.0898438 Z M12,16.0742188 C14.2734375,16.0742188 16.09375,14.2148438 16.09375,11.9960938 C16.09375,9.71484375 14.2734375,7.91796875 12,7.91796875 C9.71875,7.91796875 7.8984375,9.71484375 7.90622495,11.9960938 C7.9140625,14.2148438 9.71875,16.0742188 12,16.0742188 Z M12,13.3320312 C11.2578125,13.3320312 10.6484375,12.7304688 10.6484375,11.9960938 C10.6484375,11.2539062 11.2578125,10.6523438 12,10.6523438 C12.7421875,10.6523438 13.3515625,11.2539062 13.3515625,11.9960938 C13.3515625,12.7304688 12.7421875,13.3320312 12,13.3320312 Z",
  id: "Visibility",
  fill: "#2D3439",
  fillRule: "nonzero"
})))));

function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "14px",
    viewBox: "0 0 22 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-M/OnLight/Visibility/Default/On") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon_eye.41ee20e3.svg";
export { ForwardRef as ReactComponent };